import { useState, useEffect, useMemo } from 'react';

const useTypingEffect = (fullText: string, typingSpeed: number = 60) => {
  // Split into full characters so surrogate pairs (e.g. emoji) never render half-typed
  const characters = useMemo(() => Array.from(fullText), [fullText]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setCurrentIndex(0);
  }, [characters]);

  useEffect(() => {
    if (currentIndex < characters.length) {
      const timeoutId = setTimeout(() => {
        setCurrentIndex(prev => prev + 1);
      }, typingSpeed);

      return () => clearTimeout(timeoutId);
    }
  }, [currentIndex, characters, typingSpeed]);

  return characters.slice(0, currentIndex).join('');
};

export default useTypingEffect;
